import { clsx } from "@trydig/ui";
import type { TSize } from "~/components/ui/VariantPicker";
import styles from "./SizePicker.module.css";

export interface SizePickerProps {
	sizes: TSize[];
}

export const SizePicker = ({ sizes }: SizePickerProps) => {
	return (
		<div className={styles.sizes}>
			{sizes?.map((size, i) => {
				return (
					<button
						key={size.size + i}
						className={clsx(styles.size, size.selected && styles.selected)}
						onClick={size.select}
					>
						{size.size}
					</button>
				);
			})}
		</div>
	);
};
